import { Component, Input, Output, OnInit, ViewChild, EventEmitter } from '@angular/core';
import { Region } from './region-model';
import { UserManagmentService } from '../../user-managment.service';
import { ErrorHandler } from '@root/utils/error-handler.service';
import { ToastrService } from 'ngx-toastr';
import { NgForm } from '@angular/forms';


@Component({
  selector: 'app-region',
  templateUrl: './region.component.html',
  styleUrls: ['./region.component.scss'],
  providers: [UserManagmentService]
})
export class RegionComponent implements OnInit {

  @ViewChild('f', { static: false }) form: NgForm;

  @Input() region: Region;

  @Output() refresh = new EventEmitter();

  constructor(  public userManagmentService: UserManagmentService,
                private toastr: ToastrService,
                private errorHandler: ErrorHandler) { }

  ngOnInit() {
  }

   /***
   * Special Character validation
   */
  keyPressAlpha(event: any) {
    const pattern = /[a-zA-Z0-9 ]/;

    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }


  public processRegion(){
    this.userManagmentService.createOrUpdateRegion(this.region).subscribe(
      response => {
        if(response.status === 0){
          this.toastr.success(response.message);
          this.refresh.emit();
          this.resetForm();
        }else{
          this.errorHandler.handleError(response);
        }

      },
      error => {
        this.errorHandler.handleError(error);
      }
    )
  }

  resetForm(){
    this.form.resetForm();
  }
}
